import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DtoDetailStation from '../../dto/DtoDetailStation'
import MapDetailStationPanel from '../map/MapDetailStationPanel'
import { find } from 'lodash'
import DtoIndustrialSite from '../../dto/DtoIndustrialSite'
import DtoIndustrialSeveso from '../../dto/DtoIndustrialSeveso'
import DtoIndustrialFamily from '../../dto/DtoIndustrialFamily'
import DtoIndustrialActivity from '../../dto/DtoIndustrialActivity'
import DtoCity from '../../../referential/dto/DtoCity'
import i18n from 'simple-react-i18n'

class IndustrialSitePanel extends Component {

	getDetailLine = (title, value) => {
		return (
			<div className='row'><b>{ title }</b><br/>
				<span className='black-text'> { value }</span><br/>
			</div>
		)
	}

	getCoordinate = () => {
		if (this.props.station.site.localization) {
			const title = i18n.point.coordinate
			const coordinate = 'X: ' + this.props.station.site.localization.xCoordinate + ' - ' + 'Y: ' + this.props.station.site.localization.yCoordinate
			return this.getDetailLine(title, coordinate)
		}
		return null
	}

	getStandartCode = (list, code) => {
		return find(list, (o) => {
			return o.code == code
		})
	}

	getSector = () => {
		if (this.props.industrialSite.activityCode) {
			const result = this.getStandartCode(this.props.industrialActivity, this.props.industrialSite.activityCode)
			if (result) {
				return this.getDetailLine(i18n.activityArea, result.definition)
			}
			return this.getDetailLine(i18n.activityArea, i18n.notSpecified)
		}
		return this.getDetailLine(i18n.activityArea, i18n.notSpecified)
	}

	getState = () => {
		if (this.props.industrialSite.state) {
			return this.getDetailLine(i18n.state, this.props.industrialSite.state)
		}
		return this.getDetailLine(i18n.state, i18n.notSpecified)
	}
	getNaf = () => {
		return this.getDetailLine(i18n.nafCode, i18n.notSpecified)
	}
	getICPE = () => {
		return this.getDetailLine(i18n.icpeScheme, i18n.notSpecified)
	}
	getSeveso = () => {
		if (this.props.industrialSite.sevesoCode) {
			const result = this.getStandartCode(this.props.industrialSeveso, this.props.industrialSite.sevesoCode)
			if (result) {
				return this.getDetailLine('Seveso', result.definition)
			}
			return this.getDetailLine('Seveso', i18n.notSpecified)
		}
		return this.getDetailLine('Seveso', i18n.notSpecified)
	}

	getFamily = () => {
		if (this.props.industrialSite.familyCode) {
			const result = this.getStandartCode(this.props.industrialFamily, this.props.industrialSite.familyCode)
			if (result) {
				return this.getDetailLine(i18n.family, result.definition)
			}
			return this.getDetailLine(i18n.family, i18n.notSpecified)
		}
		return this.getDetailLine(i18n.family, i18n.notSpecified)
	}
	getComment = () => {
		if (this.props.station.site && this.props.station.site.comment) {
			return this.getDetailLine(i18n.comment, this.props.station.site.comment)
		}
		return this.getDetailLine(i18n.comment, i18n.notSpecified)
	}
	getCity = () => {
		if (this.props.station.site.city) {
			const city = find(this.props.cities, (o) => {
				return o.id == this.props.station.site.city
			})
			if (city) {
				const title = i18n.town
				const value = city.name + ' [' + city.code + ']'
				return this.getDetailLine(title, value)
			}
			return null
		}
		return null
	}

	getContent = () => {
		if (this.props.industrialSite) {
			return (<div>
				{ this.getCoordinate() }
				{ this.getState() }
				{ this.getSector() }
				{ this.getFamily() }
				{ this.getSeveso() }
				{ this.getNaf() }
				{ this.getICPE() }
				{ this.getComment() }
			</div>)
		}
		return (<div>{ i18n.warning.noDataAvailableSite }</div>)
	}

	render() {
		return (
			<div className='row no-margin card-title'>
				<div className='col s12 m12 l12 no-padding'>
					<div className='row no-margin white-background'>
						<div className='col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin'>
							<div className='row primary-light white-text no-margin'>
								<div className='col l12'><h5>{ i18n.description }</h5></div>
							</div>
						</div>
					</div>
					<div className='row no-margin white-background'>
						<div className='col s6'>
							{ this.getCity() }
							{ this.getContent() }
						</div>
						<div className='col s6 card-title hide-on-med-and-down'>
							<MapDetailStationPanel height={ this.props.height - 200 }/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

IndustrialSitePanel.propTypes = {
	station: PropTypes.objectOf(DtoDetailStation),
	height: PropTypes.number,
	cities: PropTypes.arrayOf(PropTypes.instanceOf(DtoCity)),
	industrialSite: PropTypes.objectOf(DtoIndustrialSite),
	industrialActivity: PropTypes.arrayOf(PropTypes.instanceOf(DtoIndustrialActivity)),
	industrialFamily: PropTypes.arrayOf(PropTypes.instanceOf(DtoIndustrialFamily)),
	industrialSeveso: PropTypes.arrayOf(PropTypes.instanceOf(DtoIndustrialSeveso))
}

IndustrialSitePanel.defaultProps = {
	height: 250
}
const mapStateToProps = store => {
	return {
		station: store.DetailStationReducer.station,
		cities: store.ReferentialReducer.cities,
		industrialSite: store.DetailStationReducer.industrialSite,
		industrialActivity: store.DetailStationReducer.industrialActivity,
		industrialFamily: store.DetailStationReducer.industrialFamily,
		industrialSeveso: store.DetailStationReducer.industrialSeveso
	}
}
export default connect(mapStateToProps)(IndustrialSitePanel)



// WEBPACK FOOTER //
// ./src/station/components/industrialSite/IndustrialSitePanel.js